import { EVENT_COUNT_LIMIT, MAX_ATTEMPTS } from './defaults';
import { Logger, ResilienceOptions } from './types';

export const createOptionsWithDefaults = (options: ResilienceOptions): Required<ResilienceOptions> => ({
  logger: options.logger || console,
  useMemory: options.useMemory || false,
  maxAttempts: options.maxAttempts || MAX_ATTEMPTS,
  // This is so that we can customise `maxEventLimit`, primarily for testing.
  maxEventLimit: options.maxEventLimit || EVENT_COUNT_LIMIT,
});

  // For requests that are not mission critical
export const monitorErrorsOnRequest = (request: IDBRequest, logger: Logger): void => {
  request.onerror = (event) => {
    logger.warn('Error thrown from request:', event);
  };
}
